<div class="h-full select-none text-left" [ngClass]="cssClass()">
  <div class="truncate text-sm font-bold leading-relaxed" data-testid="tab-name-vehicle" title="{{ vehicle()?.name }}">
    {{ vehicle()?.name }}
  </div>
  <div class="truncate text-xs">
    <span class="pr-1">{{ vehicle()?.output }} kW</span>
    <span class="pr-1">{{ fuelTypesString() }}</span>
    <span class="pr-1">{{ vehicle()?.capacity }} ccm</span>
    <span class="pr-1">({{ vehicle()?.engineCode }})</span>
    <!-- <span class="pr-1">{{ vehicle()? | powerRange:'kw' }} -->
    <!-- {{ vehicle()? | powerRange:'hp' }}</span> -->
  </div>

  @if (hideCloseButton === false) {
    <app-close-tab-button [tab]="tab()" class="!absolute inset-y-0 right-0" iconClass="!w-4 !h-4" (onClose)="onTabClose()" />
  }
</div>
